import React from 'react';

const VideoSection = () => {
  const videos = [
    { thumbnail: '/video1.jpg', url: 'https://youtu.be/PAaCfaCNImg?si=VNqfB41IfhmZhRF3' },
    { thumbnail: '/video2.jpg', url: 'https://youtu.be/yz6u7rJkOhM?si=QLbdRm3TeRYFAv9D' },
    { thumbnail: '/video3.jpg', url: 'https://youtu.be/OASeEho1o2o?si=2uxI8JVWHe6pzDU1' },
    { thumbnail: '/video4.jpg', url: 'https://youtu.be/rYs2PBlDe8M?si=NxN_GzSjppt3ahro' }
  ];

  return (
    <section className="py-12 md:py-16 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4 text-center">
        <h2 className="font-bold text-2xl md:text-3xl mb-8 text-gray-900">
          A Sneak Peek of <span className="text-red-600">Past Events</span>
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8 max-w-6xl mx-auto">
          {videos.map((video, index) => (
            <a
              key={index}
              href={video.url}
              target="_blank"
              rel="noopener noreferrer"
              className="block relative group overflow-hidden rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300"
            >
              <img
                src={video.thumbnail}
                alt={`Video ${index + 1}`}
                className="w-full h-auto transform group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 transition-all duration-300 flex items-center justify-center">
                <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center opacity-80 group-hover:opacity-100 transition-opacity duration-300 shadow-lg">
                  <svg className="w-8 h-8 text-white ml-1" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M6.3 2.841A1.5 1.5 0 004 4.11V15.89a1.5 1.5 0 002.3 1.269l9.344-5.89a1.5 1.5 0 000-2.538L6.3 2.84z" />
                  </svg>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default VideoSection;